
"use client";

import type React from 'react';
import { createContext, useContext, useState, useMemo } from 'react';

interface InterviewInProgressContextType {
  isInterviewInProgress: boolean;
  setIsInterviewInProgress: (isInProgress: boolean) => void;
}

const InterviewInProgressContext = createContext<InterviewInProgressContextType | undefined>(undefined);

export const InterviewInProgressProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isInterviewInProgress, setIsInterviewInProgress] = useState(false);

  const value = useMemo(() => ({
    isInterviewInProgress,
    setIsInterviewInProgress,
  }), [isInterviewInProgress]);

  return (
    <InterviewInProgressContext.Provider value={value}>
      {children}
    </InterviewInProgressContext.Provider>
  );
};

export const useInterviewInProgress = (): InterviewInProgressContextType => {
  const context = useContext(InterviewInProgressContext);
  if (context === undefined) {
    throw new Error('useInterviewInProgress must be used within an InterviewInProgressProvider');
  }
  return context;
};
